import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link, withRouter} from "react-router-dom";
import styled from 'styled-components';

import ICON_BACK from '../../shared/images/back.png'

const NavBarDiv = styled.div`

    padding: 18px 30px;
    color: rgba(0, 0, 0, 0.3);
    font-size: 13.5px;
    line-height: 30px;
    
.nav-back-button {
  cursor: pointer;
  line-height: 32px !important;

  @media (min-width: 1000px) {
    padding-left: 105px;
  }
}    

.nav-back-button img {
  position: relative;
  top: -2px;
}

.navBarContainer a {
    color: inherit;
    line-height: inherit;
}

.title {
    padding: 0 7.125px;
    line-height: 30px;
}

.actions {
    text-align: right;
    flex: 1;
    
    img {
      position: relative;
      top: -2px; //quick fix for compare button
    }
}

`


class NavBar extends Component {

    static propTypes = {
        title: PropTypes.string,
      actions: PropTypes.object,
        isBack: PropTypes.bool,
    };

  onBackClicked = ()=>{
    if(!this.props.isBack)
      this.props.history.goBack();
    else
        this.props.goToPage();
  }

    render() {
      return <NavBarDiv className={"d-flex flex-row"}>
        <div className={'nav-back-button'} onClick={this.onBackClicked}>
          <img src={ICON_BACK} style={{width: 'auto', height: 24, padding: '0 0'}} alt=""/>
          <div className={`d-inline-block ${'title'}`}>{this.props.title}</div>
        </div>

        <div className={'actions'}>
          {
            this.props.actions
          }
        </div>
      </NavBarDiv>
    }
}

export default withRouter(NavBar);


// WEBPACK FOOTER //
// ./src/components/nav-bar/NavBar.js